import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import withUserManager from './withUserManager';
import AccessForbidden from '../elements/banners/AccessForbidden';

const PrivateRoute = props => {
  if (props.location.pathname !== '/_cb') {
    if (!props.userManager.isAuthenticated()) {
      props.userManager.signin({ path: props.location.pathname });
      return null;
    }
    if (!props.userManager.hasProductPermission()) {
      return <AccessForbidden />;
    }
  }
  return <Route {...props} />;
};

PrivateRoute.propTypes = {
  location: PropTypes.object.isRequired,
  userManager: PropTypes.object.isRequired
};

export default withRouter(withUserManager(PrivateRoute));



// WEBPACK FOOTER //
// ./src/common/jsx/auth/PrivateRoute.js